import { createAsyncThunk } from "@reduxjs/toolkit";
//import { updateDefaultCountry } from "store/services/countries";
import {
  getHoliday,
  addHoliday,
  updateHoliday,
  deleteHoliday,
} from "store/services/dataManagement/holiday";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";
export const GetAllHolidayAction = createAsyncThunk(
  "holiday/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getHoliday(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const AddHolidayAction = createAsyncThunk(
  "holiday/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { filter, onSuccess, onError, ...rest } = payload;
    try {
      const res = await addHoliday(rest);
      if (res.status === 1) {
        dispatch(closeAdminModal());
        const responce = await getHoliday(filter);
        if (responce.status === 1) {
          if (onSuccess) {
            onSuccess();
          }
          return fulfillWithValue(responce);
        }
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);

export const UpdateHolidayAction = createAsyncThunk(
  "holiday/edit",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateHoliday(rest);
      if (res.status === 1) {
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);

export const DeleteHolidayAction = createAsyncThunk(
  "color/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSuccess, onError, ...rest } = payload;
      const res = await deleteHoliday(rest);
      if (res.status === 1) {
        if (onSuccess) onSuccess();
        const responce = await getHoliday(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
